import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from '@services/theme.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [CommonModule],
  standalone: true
})
export class HeaderComponent {
  @Input({ required: true }) logoSrc!: string;
  @Input({ required: true }) lang!: string;

  theme!: any;
  selectedLang!: string;
  availableHidden = false;

  constructor(private themeService: ThemeService, private translate: TranslateService){
    this.themeService.getCurrentTheme().subscribe(theme => {
      this.theme = theme;
      this.setSelectedLang(localStorage.getItem('lang')!);
    });
  }

  getSelectedFlag(){
    return this.theme.header.lang.available.find((flag: any) => flag.name === this.selectedLang)?.flag;
  }

  setSelectedLang(lang: string){
    this.selectedLang = lang;
    this.translate.use(this.theme.name.toLowerCase() + '-' + lang);
    localStorage.setItem('lang', lang);
  }
}
